module.exports = __webpack_public_path__ + "static/img/xiangqing2.9c9063f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/xiangqing2.png
// module id = y+vu
// module chunks = 24